import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { NotificationsService } from 'src/app/services/notifications.service';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'menu-notifications, app-menu-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: true,
    imports: [MatIconButton, MatIcon, MatDivider, MatButton, AsyncPipe]
})
export class NotificationsComponent implements OnInit {
  auth = inject(AuthService);


  notificationsService = inject(NotificationsService)

  notifications: any = false
  user: any

  intervals = [
    { label: 'y', seconds: 31536000 },
    { label: 'mo', seconds: 2592000 },
    { label: 'd', seconds: 86400 * 7 },
    { label: 'd', seconds: 86400 },
    { label: 'h', seconds: 3600 },
    { label: 'm', seconds: 60 },
    { label: 's', seconds: 1 }
  ];

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);
  constructor() { }
 
  ngOnInit(): void {

    this.auth.user$.subscribe((response) => {
      this.user = response
      
      if(response) {

        this.notificationsService.streamNotifications(this.user.uid).subscribe((notifications) => {
    
          if(notifications) {
            this.notifications = Object.values<{date: number, message: string, read: boolean, title: string}>(notifications)
              .filter((notification) => notification.read == false)
              .sort((a, b) => {
                return b.date - a.date
              })
              .splice(0, 5)
          }
        })
      }
    })
  }

  /**
   * Returns an observable with time, if interval is less than 1, return the text "Just now"
   * 
   * @param date
   */
  getTime(date) {

    const seconds = Math.floor((Date.now() - date) / 1000);

    return of(this.intervals.find(i => i.seconds < seconds))
      .pipe(map((interval) => {

        if(!interval) {
          return 'Just now'
        }

        const count = Math.floor(seconds / interval.seconds);
        return `${count}${interval.label} ago`;

      }))
  }

  readNotification(notification) {
    notification.read = true
    this.notificationsService.updateNotification(this.user.uid, {[notification.date]: notification})
  }

  markAll() {

    let preparedNotifications = []

    for(let notification of this.notifications) {
      
      notification.read = true
      preparedNotifications.push(notification)
    }

    for(let notification of preparedNotifications) {

      this.notificationsService.updateNotification(this.user.uid, {[notification.date]: notification})
    }
  }
}
